import {FP_VOUCHER_TYPES} from '../../../../../common/const/free_play_consts';
import FreePlayVoucherComponentController from './free_play_voucher_component_controller';
import {IFreePlayVoucherData} from "../../../../../common/interfaces/free-play/free-play-voucher-data.interface";

export const VOUCHER_STATE = {
    INIT: 'Init',
    INFO: 'Info',
    GAMES: 'Games'
};

export const VOUCHER_VIEW = require('./view/free_play_voucher.html');

export const EXPIRATION_TYPE = {
    TIME: 'time',
    DAY: 'day',
    EXPIRED: 'expired'
};

export const CSS_CLASSES = {
    VOUCHER_EXPIRATION_CLASS: 'cgp-fp-expiration',
    VOUCHER_INFO_SELECTOR: 'cgp-fp-info-img',
    VOUCHER_CLOSE_SELECTOR: 'cgp-fp-close-img',
    VOUCHER_NEW_CLASS: 'cgp-fp-new-wrapper',
    VOUCHER_EXPIRATION_SOON_CLASS: ['cgp-theme-property-color-base04', 'cgp-theme-property-font-type-secondary'],
    VOUCHER_EXPIRATION_DAY: 'cgp-theme-property-color-base01',
    VOUCHER_EXPIRED_CLASS: 'cgp-fp-expired',
    VOUCHER_CONTAINER_CLASS: 'cgp-fp-voucher-container',
    VOUCHER_CONTAINER_SELECTOR: '.cgp-fp-voucher-container'
};

export const TRANSLATIONS = {
    VOUCHER_NAME: 'free_play_voucher_name_',
    VOUCHER_DESC: 'free_play_voucher_desc_',
    VOUCHER_REWARDS_AMOUNT: 'free_play_voucher_reward_amount',
    VOUCHER_REWARDS_BALANCE: 'free_play_voucher_reward_balance',
    VOUCHER_BALANCE_PREFIX: 'free_play_voucher_balance_prefix',
    VOUCHER_EXPIRATION: 'free_play_expires_in_'
};

export const FP_VOUCHER_TYPE_NAMES = {
    [FP_VOUCHER_TYPES.FreeSpin]: 'FSV',
    [FP_VOUCHER_TYPES.FreePlay]: 'FPV',
    [FP_VOUCHER_TYPES.FreeJackpotSpin]: 'JPFSV',
    [FP_VOUCHER_TYPES.FreeJackpotPlay]: 'JPFPV'
};

export const FP_VOUCHER_ICONS_CLASSES = {
    [FP_VOUCHER_TYPES.FreeSpin]: 'cgp-themes-icons-fp-voucher-free-spin',
    [FP_VOUCHER_TYPES.FreePlay]: 'cgp-themes-icons-fp-voucher-free-play',
    [FP_VOUCHER_TYPES.FreeJackpotSpin]: 'cgp-themes-icons-fp-voucher-jackpot-free-spin',
    [FP_VOUCHER_TYPES.FreeJackpotPlay]: 'cgp-themes-icons-fp-voucher-jackpot-free-play'
};

export const FP_VOUCHER_BACKGROUND_CLASSES = {
    [FP_VOUCHER_TYPES.FreeSpin]: 'cgp-themes-icons-fp-voucher-bg-free-spin',
    [FP_VOUCHER_TYPES.FreePlay]: 'cgp-themes-icons-fp-voucher-bg-free-play',
    [FP_VOUCHER_TYPES.FreeJackpotSpin]: 'cgp-themes-icons-fp-voucher-bg-jackpot-free-spin',
    [FP_VOUCHER_TYPES.FreeJackpotPlay]: 'cgp-themes-icons-fp-voucher-bg-jackpot-free-play'
};

export type IAlteredFreePlayVoucher = IFreePlayVoucherData & {
    isNew: boolean;
    component?: FreePlayVoucherComponentController;
    games: number[];
};
